import { render, staticRenderFns } from "./FileDetailPage.vue?vue&type=template&id=38edcbd0&scoped=true&"
import script from "./FileDetailPage.vue?vue&type=script&lang=js&"
export * from "./FileDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./FileDetailPage.vue?vue&type=style&index=0&id=38edcbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38edcbd0",
  null
  
)

export default component.exports